import PromptMediaPreview from "@src/features/libraryItem/course/PromptMediaPreview";
import EmojiPreview from "@src/lib/ui/EmojiPreview";
import { FC, useMemo } from "react";
import { isGiphyUrl } from "./utils/utils";
import {
  mediaBoxAspectRatio,
  ResolvedPromptMediaLayout,
} from "@src/features/libraryItem/shared/promptMediaLayout";

type Props = {
  id: string;
  mediaUrl?: string;
  emoji?: string;
  showViewButton?: boolean;
  isGifConvertedToMp4?: boolean;
  disableFastForward?: boolean;
  onVideoComplete?: () => void;
  /** A course screen's author-managed layout; null keeps the natural size. */
  layout?: ResolvedPromptMediaLayout | null;
};

const MediaPreview: FC<Props> = (props) => {
  return useMemo(() => {
    if (props.mediaUrl) {
      const preview = (
        <PromptMediaPreview
          promptUuid={props.id}
          url={props.mediaUrl}
          isGifConvertedToMp4={props.isGifConvertedToMp4}
          title={""}
          style={{ width: "100%" }}
          unfurledMediaProps={{
            ogVideoIframeProps: {
              style: {
                minWidth: "100%",
                height: 200,
              },
            },
          }}
          showViewButton={props.showViewButton ?? !isGiphyUrl(props.mediaUrl)}
          disableFastForward={props.disableFastForward}
          onVideoComplete={props.onVideoComplete}
          layout={props.layout}
        />
      );
      if (!props.layout) return preview;
      return (
        <div
          data-testid="managed-media-box"
          className="flex w-full overflow-hidden"
          style={{
            aspectRatio: mediaBoxAspectRatio(props.layout.heightPercent),
          }}
        >
          {preview}
        </div>
      );
    } else if (props.emoji) {
      return (
        <div
          className="mx-1.5 mt-1.5 flex flex-col items-center self-stretch"
          style={{
            position: "relative",
            borderRadius: 26,
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <EmojiPreview emoji={props.emoji} />
        </div>
      );
    } else {
      return null;
    }
  }, [props]);
};

export default MediaPreview;
